import * as React from 'react';

import { FaqPageLocale } from './faqPage.locale';
import Header from '../Header/Header';
import headerBg from './headerBg.svg';
import FaqItem from './FaqItem/FaqItem';
import Cta from '../Cta/Cta';
import LinkButton from '../Button/LinkButton';

interface FaqPageProps {
  locale: FaqPageLocale;
  openedFaqIndex: number | null;
  toggleFaq: (index: number) => void;
}

const FaqPage: React.SFC<FaqPageProps> = ({ locale, openedFaqIndex, toggleFaq }) => (
  <>
    <Header
      title="FAQ"
      subtitle={locale.subtitle}
      backgroundImage={headerBg}
      backgroundPosition="center 35%"
      backgroundSize="auto 180%"
    />
    <main>
      <section className="container py-8">
        {locale.faqs.map((faq, index) => (
          <FaqItem
            key={index}
            locale={faq}
            toggleFaq={() => toggleFaq(index)}
            isLast={index === locale.faqs.length - 1}
            isOpened={index === openedFaqIndex}
          />
        ))}
      </section>
      <Cta title={locale.cta.title} backgroundType="circles">
        <LinkButton to={locale.cta.button.href}>{locale.cta.button.text}</LinkButton>
      </Cta>
    </main>
  </>
);

export default FaqPage;



// WEBPACK FOOTER //
// /www/client/src/components/FaqPage/FaqPage.tsx